module.exports = __webpack_public_path__ + "static/img/2.59c326b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/2.jpg
// module id = RYWd
// module chunks = 0